import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputBase from '@material-ui/core/InputBase';
import { store } from "../../../../helpers/store"
import { useEffect,useState } from "react";
import { useSelector } from "react-redux";
import billingHistoryService from "../../service/e_billing-history-service";
import { blue,grey} from "@material-ui/core/colors";
import ExpandMoreSharpIcon from "@material-ui/icons/ExpandMoreSharp";

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid '+ grey[400],
    fontSize: "0.8rem",
    padding: '2% 2% 2% 0.8rem',
    color: theme.palette.eDark?.base,
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderRadius: 4,
      backgroundColor: theme.palette.background.paper,
    },
  },
}))(InputBase);

const useStyles = makeStyles((theme) => ({
  margin: {
    marginTop: theme.spacing(0),
  },
  menuItems: {
    justifyContent: "flex-start !important",
    color: theme.palette.eRich?.base+" !important",
    fontSize: "0.8rem",
  },
}));

export default function DatesDropdown(props) {
  const useStyleClasses = useStyles();
  const [value, setValue] = React.useState(props.cat);
  if(value !== props.cat){
    setValue(props.cat);
  }
  return (
    <div>
      <FormControl className={useStyleClasses.margin}>
        <Select
          id="demo-customized-select-native"
          value={value}
          onChange={props.handler}
          input={<BootstrapInput />}
          IconComponent={ExpandMoreSharpIcon}
          MenuProps={{
            disableScrollLock: false,
            anchorOrigin: {
                vertical: "bottom",
                horizontal: "right"
            },
            transformOrigin: {
                vertical: "top",
                horizontal: "right",
            },
            getContentAnchorEl: null
        }}
        >
          <MenuItem classes={{root: useStyleClasses.menuItems}} value={0}>{props.props.allDates}</MenuItem>
          <MenuItem classes={{root: useStyleClasses.menuItems}} value={1}>{props.props.currentMonthDates}</MenuItem>
          <MenuItem classes={{root: useStyleClasses.menuItems}} value={2}>{props.props.lastMonth}</MenuItem>
          <MenuItem classes={{root: useStyleClasses.menuItems}} value={3}>{props.props.threeMonths}</MenuItem>
          <MenuItem classes={{root: useStyleClasses.menuItems}} value={4}>{props.props.sixMonths}</MenuItem>
          <MenuItem classes={{root: useStyleClasses.menuItems}} value={5}>{props.props.twelveMonths}</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
}